import { useState, useEffect } from "react";
import { MessageCircle, Phone } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export default function FloatingContact() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToContact = () => {
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {visible && (
        <>
          {/* Desktop: message icon → scroll to contact */}
          <motion.button
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 20 }}
            onClick={scrollToContact}
            data-testid="floating-contact-button"
            className="hidden md:flex fixed bottom-8 left-8 z-50 w-14 h-14 rounded-full bg-[#73B5E2] hover:bg-[#5AA0D0] text-white shadow-lg shadow-blue-500/30 items-center justify-center transition-colors hover:scale-110"
            title="Nous contacter"
          >
            <MessageCircle className="w-6 h-6" />
          </motion.button>

          {/* Mobile: phone icon button bottom-left */}
          <motion.a
            href="tel:+41794595160"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 20 }}
            data-testid="floating-phone-mobile"
            className="md:hidden fixed bottom-8 left-5 z-50 w-14 h-14 rounded-full bg-[#73B5E2] hover:bg-[#5AA0D0] text-white shadow-lg shadow-blue-500/30 flex items-center justify-center transition-colors"
          >
            <Phone className="w-6 h-6" />
          </motion.a>
        </>
      )}
    </AnimatePresence>
  );
}
